import ItemWithBadges from '~/components/dashboard/soapV2/collapsibleRail/summary/ItemWithBadges'
import type { Order } from '~/types'
import ProcedureActions from '~/utils/actions/ProcedureActions'
import ProcedureButtonSection from '~/utils/button-sections/ProcedureButtonSection'
import ProcedureContent from '~/utils/content/ProcedureContent'

export interface ProcedureProps {
  data: Order
}

const Procedure = ({ data, ...rest }: ProcedureProps) => (
  <ItemWithBadges
    actions={<ProcedureActions order={data} {...rest} />}
    buttonSection={<ProcedureButtonSection order={data} {...rest} />}
    order={data}
  >
    <ProcedureContent order={data} />
  </ItemWithBadges>
)

export default Procedure
